import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["data-testid"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationSettingsFieldError',
    props: {
        message: {},
        testId: {}
    },
    setup(__props) {
        /** The inline error line OPAL inputs render under a field, for errors no input owns. */
        return (_ctx, _cache) => {
            return (__props.message)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    role: "alert",
                    class: "flex items-center gap-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)",
                    "data-testid": __props.testId
                }, [
                    _cache[0] || (_cache[0] = _createElementVNode("i", {
                        class: "ri-error-warning-fill",
                        "aria-hidden": "true"
                    }, null, -1 /* CACHED */)),
                    _createElementVNode("span", null, _toDisplayString(__props.message), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_1))
                : _createCommentVNode("v-if", true);
        };
    }
});
